import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { BASE_URL } from "Assets/baseUrl/BaseUrl"

const User_Id = localStorage.getItem("adminId")
const getAdminId = localStorage.getItem("adminId")

export const addAddress = createAsyncThunk(
  "addresses/addAddress",
  async ({ addressId, userId }, thunkAPI) => {
    try {
      const response = await axios.post(`${BASE_URL}/v1/propertyAddress/save`, {
        addressId,
        userId,
      })

      return response.data
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
)

// Async thunk to handle the GET API call
export const fetchSavedAddress = createAsyncThunk(
  "addresses/fetchSavedAddress",
  async (userId, thunkAPI) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/v1/propertyAddress/get/user/${userId}`
      )
      return response.data?.addresses
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
)

// For  fetching client secret

export const fetchClientSecret = createAsyncThunk(
  "addresses/fetchClientSecret",
  async (adminId, thunkAPI) => {
    try {
      const response = await axios.post(
        "https://stonecore-2024.uc.r.appspot.com/v1/stripe/create-setup-intent",
        {
          _id: adminId,
          usage: "off_session",
        }
      )

      if (response.status !== 200) {
        throw new Error("Failed to fetch client secret")
      }

      const { setupIntent, adminCustomer } = response.data
      if (setupIntent && setupIntent.client_secret) {
        return {
          clientSecret: setupIntent.client_secret,
          customerName: adminCustomer.firstName,
        }
      } else {
        throw new Error("Invalid response format")
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data)
    }
  }
)

// export const createSubscription = createAsyncThunk(
//     'addresses/createSubscription',
//     async ({ userId, paymentMethod, addressId }, thunkAPI) => {
//         console.log("Creating subscription with parameters:", { userId, paymentMethod, addressId });
//         const url = "https://stonecore-2024.uc.r.appspot.com/v1/stripe/create-subscription";
//         const body = JSON.stringify({
//             userId,
//             paymentMethod: "pm_1PWFq5P91pMZMWO6UazMkPBh",
//             addressId,
//         });

//         try {
//             const response = await fetch(url, {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: body,
//             });

//             if (!response.ok) {
//                 throw new Error("Failed to create subscription");
//             }

//             const result = await response.json();
//             return result;
//         } catch (error) {
//             return thunkAPI.rejectWithValue(error.message);
//         }
//     }
// );

export const createSubscription = createAsyncThunk(
  "addresses/createSubscription",
  async ({ userId, paymentMethod, addressId }, thunkAPI) => {
    const url =
      "https://stonecore-2024.uc.r.appspot.com//v1/stripe/subscription/create"
    const results = []
    try {
      const body = {
        userId,
        paymentMethod,
        addressId,
      }
      const response = await axios.post(url, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      results.push(response.data) // Collect results for each payment method ID
    } catch (error) {
      // Handle errors or reject with error message
      results.push({ error: error?.response?.data?.message || error.message })
    }

    return results
  }
)

const addressSlice = createSlice({
  name: "addresses",
  initialState: {
    selectedAddress: [],
    savedAddressData: [],
    selectedBuildingAddress: null,
    paymentMethodId: [],
    userId: null,
    clientSecret: null,
    customerName: "",
    status: "idle",
    error: null,
    refetchCards: false,
  },

  reducers: {
    // Add other synchronous reducers here if needed
    setSelectedBuildingAddress: (state, action) => {
      state.selectedBuildingAddress = action.payload
    },
    setSavedAddressData: (state, action) => {
      state.savedAddressData = action.payload
    },
    setRefetchCard: (state, action) => {
      state.refetchCards = !state.refetchCards
    },
    setPaymentMethodId: (state, action) => {
      // New action to set payment method ID
      state.paymentMethodId = action.payload
    },
    setUserId: (state, action) => {
      state.userId = action.payload
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(addAddress.pending, (state) => {
        state.status = "loading"
      })
      .addCase(addAddress.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.selectedAddress.push(action.payload)
      })
      .addCase(addAddress.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
      .addCase(fetchSavedAddress.pending, (state) => {
        state.status = "loading"
      })
      .addCase(fetchSavedAddress.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.savedAddressData = action.payload
      })
      .addCase(fetchSavedAddress.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
      .addCase(fetchClientSecret.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.clientSecret = action.payload.clientSecret
        state.customerName = action.payload.customerName
      })
      .addCase(fetchClientSecret.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
      .addCase(createSubscription.pending, (state) => {
        state.status = "loading"
      })
      .addCase(createSubscription.fulfilled, (state, action) => {
        state.status = "succeeded"
        // Handle success logic, e.g., storing subscription details
      })
      .addCase(createSubscription.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const {
  setSavedAddressData,
  setSelectedBuildingAddress,
  setPaymentMethodId,
  setUserId,
  setRefetchCard,
} = addressSlice.actions

export default addressSlice.reducer

